module.exports = __webpack_public_path__ + "img/profile-user.5700c041.png";